import { render } from "./AttrStrMulti.vue?vue&type=template&id=b18364a0"
import script from "./AttrStrMulti.vue?vue&type=script&lang=js"
export * from "./AttrStrMulti.vue?vue&type=script&lang=js"

import "./AttrStrMulti.vue?vue&type=style&index=0&id=b18364a0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrStrMulti.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b18364a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b18364a0', __exports__)) {
    api.reload('b18364a0', __exports__)
  }
  
  module.hot.accept("./AttrStrMulti.vue?vue&type=template&id=b18364a0", () => {
    api.rerender('b18364a0', render)
  })

}


export default __exports__